module.exports = __webpack_public_path__ + "static/media/cancel.fe7498b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/cancel.svg
// module id = 961
// module chunks = 0